module.exports = __webpack_public_path__ + "fab66f4a71098e5b578098c6ff83ec06.svg";